import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toNumberedList',
  standalone: true,
})
export class ToNumberedListPipe implements PipeTransform {
  transform(text: string | null | undefined): string {
    if (!text) {
      return '';
    }

    return text
      .split(/\(\d+\)\s*/)
      .slice(1)
      .map((s) => s.trim())
      .map((item, index) => `${index + 1}. ${item}`)
      .join('\n');
  }
}
